/* eslint-disable */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@wix/ambassador/runtime/http");
exports.DealerOffersServingService = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        DealerOffersApi: function () {
            return function (headers) {
                var service = {
                    getDealerOffers: function (dealerOffersRequest) {
                        return httpClient.invoke('POST', '/api/v1/dealerOffers', dealerOffersRequest, headers);
                    },
                    getDealerOffersForRealEstates: function (dealerOffersForRealEstatesRequest) {
                        return httpClient.invoke('POST', '/api/v1/dealerOffersForRealEstates', dealerOffersForRealEstatesRequest, headers);
                    }
                };
                service.getDealerOffers.__http_method = 'POST';
                service.getDealerOffers.__http_url = '/api/v1/dealerOffers';
                service.getDealerOffersForRealEstates.__http_method = 'POST';
                service.getDealerOffersForRealEstates.__http_url = '/api/v1/dealerOffersForRealEstates';
                return service;
            };
        },
        DealerOffersServing: function () {
            return function (headers) {
                var service = {
                    debugOffer: function (debugOfferRequest) {
                        return httpClient.invoke('GET', '/v1/dealer/serving/offers/{offer_id}/debug', debugOfferRequest, headers);
                    },
                    listOffers: function (listOffersRequest) {
                        return httpClient.invoke('GET', '/v1/dealer/serving/offers', listOffersRequest, headers);
                    },
                    listOffersBulk: function (listOffersBulkRequest) {
                        return httpClient.invoke('GET', '/v1/dealer/serving/offers/bulk', listOffersBulkRequest, headers);
                    }
                };
                service.debugOffer.__http_method = 'GET';
                service.debugOffer.__http_url = '/v1/dealer/serving/offers/{offer_id}/debug';
                service.listOffers.__http_method = 'GET';
                service.listOffers.__http_url = '/v1/dealer/serving/offers';
                service.listOffersBulk.__http_method = 'GET';
                service.listOffersBulk.__http_url = '/v1/dealer/serving/offers/bulk';
                return service;
            };
        }
    };
};
exports.DealerOffersServingService.__transport = 'http';
__export(require("./types"));
